<script>
import IconCamera from "@js/components/Icons/IconCamera.vue";
import ImageSearchUploadSection from "@js/components/Sections/ImageSearch/ImageSearchUploadSection.vue";

export default {
    name: "SearchByPhotoBanner",
    components: {ImageSearchUploadSection, IconCamera}
}
</script>

<template>
    <div class="p-5 md:p-10 w-full bg-grayBg rounded-3xl text-black">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-10 h-full md:min-h-[325px]">
            <div class="flex-1 flex flex-col max-md:hidden">
                <h2 class="mb-[30px] text-2xl font-bold ">
                   <span class="underline-hover-effect underline-hover-pre-effect md:leading-10">
                        Попробуйте опцию Умного поиска по фото
                   </span>
                </h2>
                <ul class="list-disc list-outside space-y-3 ps-5 text-sm font-medium md:max-w-[80%] mt-auto">
                    <li>
                        Загружайте любое изображение товара или интерьера и находите похожие позиции за считанные секунды
                    </li>
                    <li>
                        Умная обрезка: выделяйте нужную область на фото одним кликом
                    </li>
                    <li>
                        Нейросетевой анализ формы, цвета и текстуры для максимально точного подбора
                    </li>
                    <li>
                        Подбор аналогичных моделей, сопутствующих аксессуаров и стильных решений
                    </li>
                    <li>
                        Интерактивный интерфейс с мгновенным предпросмотром результатов прямо в окне поиска
                    </li>
                </ul>
            </div>
            <div>
                <div class="flex items-center justify-start w-full h-full">
                    <ImageSearchUploadSection theme="dark"/>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
